import {Navigate, Route, Routes, useLocation, useParams} from "react-router";

import HomePage from "../views";
import ResultPage from "../views/result/ResultPage";

import LiveRouteGuard from "./LiveRouteGuard";
import {Env} from "../config";
import {LOTTERY_TABS} from "../constant/lotteryTypes";
import {isValidResultBrand, normalizeResultBrand} from "../components/result/resultAssets";

import {
    routes,
    routesBlack,
    routesV3,
    routesFull,
    routesV4,
    allLiveRoutes,
} from "./routeConfig";

const homeRoutes = [
    {
        path: "/",
        routes,
        showResultButton: true,
    },
    {
        path: "/black",
        routes: routesBlack,
        showResultButton: false,
    },
    {
        path: "/live-v3",
        routes: routesV3,
        showResultButton: true,
    },
    {
        path: "/live-full",
        routes: routesFull,
        showResultButton: true,
    },
    {
        path: "/live-v4",
        routes: routesV4,
        showResultButton: true,
    },
];

const reservedPosterPaths = new Set(["app", "result", "black", "live-v2", "live-v3", "live-v4", "live-full"]);
const posterLotteryTypes = new Set(LOTTERY_TABS.map(({value}) => value));

function PosterRoute({index = false}) {
    const {brand: routeBrand, lotteryType} = useParams();
    const {search, hash} = useLocation();
    const brand = normalizeResultBrand(routeBrand);
    if (!isValidResultBrand(brand) || reservedPosterPaths.has(brand) ||
        (!index && !posterLotteryTypes.has(lotteryType))) {
        return <p role="alert">Page not found</p>;
    }
    if (index) return <Navigate to={`/${brand}/mt${search}${hash}`} replace/>;
    return <ResultPage backTo={-1} basePath={`/${brand}`}/>;
}

export default function AppRoutes() {
    if (Env.REACT_APP_IS_POSTER) {
        return (
            <Routes>
                <Route path="/app/result/*" element={<p role="alert">Page not found</p>}/>
                <Route path="/app/:brand/:type" element={<ResultPage hideBackButton/>}/>
                <Route path="/app/:type" element={<ResultPage hideBackButton/>}/>
                <Route path="/:brand" element={<PosterRoute index/>}/>
                <Route path="/:brand/:lotteryType" element={<PosterRoute/>}/>
                <Route path="*" element={<p role="alert">Page not found</p>}/>
            </Routes>
        );
    }
    return (
        <Routes>
            <Route path="/result/:brand/:lotteryType" element={<ResultPage/>} />
            <Route path="/app/result/*" element={<p role="alert">Page not found</p>}/>
            <Route path="/app/:brand/:type" element={<ResultPage hideBackButton/>} />
            <Route
                path="/result/:lotteryType"
                element={<ResultPage/>}
            />

            <Route
                path="/app/:type"
                element={<ResultPage hideBackButton/>}
            />

            <Route element={<LiveRouteGuard/>}>
                {homeRoutes.map(({path, routes, showResultButton}) => (
                    <Route
                        key={path}
                        path={path}
                        element={
                            <HomePage
                                routes={routes}
                                showResultButton={showResultButton}
                            />
                        }
                    />
                ))}

                {allLiveRoutes.map(({path, element}) => (
                    <Route
                        key={path}
                        path={path}
                        element={element}
                    />
                ))}
            </Route>

            <Route
                path="*"
                element={<Navigate to="/result/mt" replace/>}
            />
        </Routes>
    );
}
